import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModule } from '../material.module';
import { SharedDataService } from 'src/services/shared-data.service';
import { Instrument } from 'src/models/question.model';
import { Launch } from 'src/models/launch.model';
import { FormsModule } from '@angular/forms';
import { combineLatest, tap } from 'rxjs';
import { SanitizeHtmlPipe, ReplacePatientTermPipe } from '../questions/filter-section.pipe';
import { WatermarkComponent } from '../shared/watermark/watermark.component';
import { QuestionnaireResponse } from 'src/models/questionnaire-response.model';
import { AppService } from '../app.service';
import { ResponseCreateRequest } from 'src/models/response.model';
import { LaunchStatus, ResponseStatus } from 'src/models/app-enums.model';

@Component({
  selector: 'app-intro-page',
  templateUrl: './intro-page.component.html',
  styleUrls: ['./intro-page.component.css'],
  standalone: true,
  imports: [MaterialModule, FormsModule, CommonModule, WatermarkComponent, ReplacePatientTermPipe, SanitizeHtmlPipe]
})

export class IntroPageComponent implements OnInit, OnDestroy
{
  isPhonePortrait = false;
  constructor(private responsive: BreakpointObserver,
    private router: Router,
    private shareddataService: SharedDataService,
    private _appService: AppService,
    public dialog: MatDialog,
  ) { }

  culture!: string;
  launch!: Launch
  selected: boolean = false;
  questionnaireResponse!: QuestionnaireResponse;
  instrument!: Instrument;
  isPreview: boolean = false;
  patientTerm: string | undefined = ""; //patient term at Orglevel for future implementation in Introduction, Help, Terms and Condition text

  ngOnInit(): void
  {
    localStorage.setItem("firstPage", "true");

    this.responsive.observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
      .subscribe((result) =>
      {
        this.isPhonePortrait = false;
        if (result.matches)
        {
          this.isPhonePortrait = true;
        }
      });

    combineLatest([
      this.shareddataService.questionnaireResponse$,
      this.shareddataService.instrument$,
      this.shareddataService.launch$,
      this.shareddataService.previewMode$
    ]).pipe(
      tap(([questionnaireResponse, instrument, launch, previewMode]) => {
        if (instrument && launch)
        {
          this.instrument = instrument
          this.launch = launch
          this.isPreview = previewMode

          // navigate to survey closed page if survey was closed
          const currentTimestamp: number = (new Date()).getTime()
          const endDate: number = (new Date(launch.endDate)).getTime();
          if (currentTimestamp > endDate || launch.launchStatus.toLowerCase() === LaunchStatus.LaunchClosed){
            this.router.navigateByUrl('surveyClosed/' + `${launch.launchId}`)
          }

          // navigate to page error if start date is invalid and not preview mode
          let startYear = (new Date(launch.startDate!).getFullYear())
          if ((Number.isNaN(startYear) || startYear === 1900) && !previewMode) {
            this.router.navigateByUrl('error/');
          }

          if (questionnaireResponse) {
            this.questionnaireResponse = questionnaireResponse
            // navigate to thankyou page if response is already submitted
            if (this.questionnaireResponse.submitStatus?.toUpperCase() === ResponseStatus.responseSubmitted) {
              this.router.navigateByUrl(`${'thankyou/' + this.questionnaireResponse.responseId}`);
            }
          }
        }
      })
    ).subscribe()

    this.culture = $localize.locale!;
  }

  /**
   * 
   * @returns 
   */
  beginSurvey() {

    if (this.questionnaireResponse !== undefined){
      this.router.navigateByUrl(`${'questions/response/' + this.questionnaireResponse.responseId + (this.isPreview ? "/preview" : "")}`);
      return
    }

    const responseCreateRequest: ResponseCreateRequest = {
        launchId: this.launch.launchId,
        organizationCode: this.launch.organizationCode,
        instrumentId: this.instrument.instrumentsId,
        noOfEmailIds: 1,
        availableLanguageCode: this.instrument.availableLanguages,
        isPreview: this.isPreview
    }

    this._appService.createResponse(responseCreateRequest).subscribe((questionnaireResponse) => {
      this.shareddataService.questionnaireResponse = questionnaireResponse
      this.router.navigateByUrl(`${'questions/response/' + questionnaireResponse.responseId + (this.isPreview ? "/preview" : "")}`);
    })
  }

  openPrivacyPolicy()
  {
    switch (this.culture?.toLocaleLowerCase())
    {
      case ('fr-ca'):
        window.open("https://healthstandards.org/fr/avis-de-confidentialite-plateforme-de-sondage-hso/", '_blank');
        break;
      default:
        window.open("https://healthstandards.org/privacy-notice-hso-survey-instruments-platform/", '_blank');
        break;
    }
  }

  openTermsOfUse()
  {
    switch (this.culture?.toLocaleLowerCase())
    {
      case ('fr-ca'):
        window.open("https://healthstandards.org/fr/conditions-dutilisation-plateforme-doutils-de-sondages/", '_blank');
        break;
      default:
        window.open("https://healthstandards.org/terms-of-use-survey-instruments-platform/", '_blank');
        break;
    }
  }

  ngOnDestroy(){
    try{
      localStorage.removeItem('firstPage')
    }catch(e){}
  }
}
